import { XML, XMLList } from "@goodgamestudios/xml-e4x";

export class BasicItemJsonData {
    private itemXML: XML;

    constructor() {
    }

    public parseXML(itemJsonXML: XML): void {
        this.itemXML = itemJsonXML;
    }

    public getJsonById(id: string): string {
        let data: XMLList = this.itemXML[id];
        return data.toString();
    }
}
